import { trigger, style, transition, animate, state } from '@angular/animations';

export const signUpSlideText = trigger('signUpSlideText', [
    state('false', style({ "margin-top": '0px', "font-size": '{{bigFontSize}}px', "border": "none" }),
        { params: { bigFontSize: 115 } }),
    state('true', style({ "margin-top": '{{marginTop}}px', "font-size": '{{smallFontSize}}px', "border": "2px solid white", "border-radius": "4px" }),
        { params: { smallFontSize: 36, marginTop: 260 } }),
    transition("1 => 0", animate('700ms ease-in-out')),
    transition("0 => 1", animate('700ms ease-in-out'))
]);